import { faScroll } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link, router } from "@inertiajs/react"
import { useState } from "react"

const ONLY_PROPS = ['expanded_section_references', 'previewed_reference', 'previewed_references_section', 'references_section_id', 'reference_id'];

export default function AdminReferenceCard({
  reference,
  previewedReferenceId,
  searchQuery = ''
}: any) {
  const [isHovered, setIsHovered] = useState(false);
  const navigateToReference = (path: string) => {
    const queryParam = searchQuery ? `?query=${encodeURIComponent(searchQuery)}` : '';
    router.visit(`${path}${queryParam}`, {
      preserveState: true,
      preserveScroll: true,
      only: ONLY_PROPS
    });
  };
  const backgroundImage = reference.image_url;

  const active = previewedReferenceId === reference.id

  // Determine publication status
  const getPublicationStatus = () => {
    if (!reference.published_at) {
      return { label: 'Non publié', color: '#dc2626', bgColor: '#fee2e2' } // red
    }

    const publishDate = new Date(reference.published_at)
    const now = new Date()

    if (publishDate > now) {
      return { label: 'Planifié', color: '#d97706', bgColor: '#fef3c7' } // yellow
    }

    return { label: 'Publié', color: '#16a34a', bgColor: '#dcfce7' } // green
  }

  const status = getPublicationStatus()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
        gap: '8px',
        padding: '4px 8px',
        border: '1px solid var(--color-base-300)',
        backgroundColor: active ? 'var(--color-neutral)' : isHovered ? 'var(--color-base-300)' : 'var(--color-base-200)',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => navigateToReference(`/admin/reference/${reference.references_section_id}/${reference.id}`)}
    >
      {/* Thumbnail or icon */}
      {backgroundImage ? (
        <img
          src={backgroundImage}
          alt=""
          style={{
            width: '24px',
            height: '24px',
            objectFit: 'cover',
            flexShrink: 0,
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={faScroll}
          style={{
            width: '24px',
            fontSize: '14px',
            color: 'var(--color-primary)',
            opacity: 0.7,
            flexShrink: 0,
          }}
        />
      )}

      {/* Title */}
      <span
        className="text-sm font-semibold"
        style={{
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          color: active ? 'var(--color-white)' : 'var(--color-neutral)',
        }}
      >
        {reference.title}
      </span>

      {/* Date */}
      <span
        style={{
          fontSize: '11px',
          color: active ? 'var(--color-white)' : 'var(--color-base-content)',
          opacity: 0.6,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {reference.published_at
          ? new Date(reference.published_at).toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'short',
          })
          : '—'}
      </span>

      {/* Status badge */}
      <span
        style={{
          padding: '2px 6px',
          fontSize: '10px',
          fontWeight: 600,
          color: status.color,
          backgroundColor: status.bgColor,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {status.label}
      </span>

      {/* Action links */}
      <span
        className="text-xs link link-primary"
        title="Gérer"
      >
        Gérer
      </span>
      {reference.published_at && new Date(reference.published_at) <= new Date() && (
        <Link
          href={`/references/${reference.references_section_id}/${reference.id}`}
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
          className="text-xs link link-primary"
          title="Voir"
        >
          Voir
        </Link>
      )}
    </div>
  )
}